import React, {PropTypes as T} from 'react';

const SearchIcon2 = ({ width = 17, height = 17, color = 'none', className = '' }) => (
  <svg
    aria-label="Search Icon"
    width={width}
    height={height}
    viewBox="0 0 17 17"
    xmlns="http://www.w3.org/2000/svg"
    className={`icon__search2 ${className}`}>
    <g
      strokeWidth="1.6"
      stroke="currentColor"
      fill={color}>
      <path style={{fillRule: 'evenodd'}} d="M12.52 6.76A5.76 5.76 0 1 0 1 6.76a5.76 5.76 0 0 0 11.52 0z" />
      <path style={{fillRule: 'evenodd'}} d="M16.214 16.214L11 11" strokeLinecap="round" />
    </g>
  </svg>
);

SearchIcon2.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  SearchIcon2;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_search2.js